import { useAnketaI18n } from "src/internationalization";

type Translate = ReturnType<typeof useAnketaI18n>["translate"];

const i18n = "anketa.opsanio.overview";

/**
 * Human "N min ago" label for an ISO timestamp, falling back to an absolute
 * date beyond a day. Shared by the overview KPI card and the fleet table so
 * both phrase the same timestamp identically.
 */
export const relativeLabel = (
  iso: string | null,
  translate: Translate,
): string => {
  if (!iso) return "-";
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "-";
  const diffSec = Math.round((Date.now() - then) / 1000);
  if (diffSec < 60)
    return translate(`${i18n}.time.justNow`, { defaultMessage: "just now" });
  if (diffSec < 3600)
    return translate(`${i18n}.time.minutes`, {
      values: { count: Math.floor(diffSec / 60) },
      defaultMessage: "{{count}} min ago",
    });
  if (diffSec < 86400)
    return translate(`${i18n}.time.hours`, {
      values: { count: Math.floor(diffSec / 3600) },
      defaultMessage: "{{count}} h ago",
    });
  return new Date(iso).toLocaleString("de-DE", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};
